
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "allFirm",
})
export default class allFirm extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  
  data() {
        return {
          options1: [{
            value1: '选项1',
            label1: '开业'
          }, {
            value1: '选项2',
            label1: '歇业'
          }],
          value1: '',
        }
    }

  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    
	this.getFirmList(1);
  }
  private getFirmList(num:number){
	  
	  let datas = [];
	  this.pageNo = num;
	  let pageNum = this.pageNo;
	  let pageSize = 10;
	  let paramter = {
	  	'pageSize':this.pageSize,
	  	'pageNum':this.pageNum,
	  };
	  this.$http.get("shop/list", {params:paramter}).then((res: any) => {
	  	datas = res.data.data.data;
	  	this.tableData = datas;
	  	this.tableData = this.tableData.map(item=>{
	  		
	  		let logoDatas = [];
	  		logoDatas.push(item.trademark);
	  		item.images = logoDatas;
	  		item.enable = item.enable == 1?true:false;
	  		return item;
	  	});
	  	console.log('普通用户',this.tableData);
	  });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
	this.getFirmList(this.pageNo);
  }
  private userStateChange(enable){
	  
	  // 启用权限
    console.log(enable);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private showOrder(row){
	  
	  console.log(row);
	  this.$router.push('/Firm/firmOrder/?id='+row.id);
  }
  private handleEdit(row){
  	  
	  console.log('多少',row);
	  this.$router.push('/Firm/editFirm/?id='+row.id)
  }
}
